<script>
export default {
    sign_in_with: 'Se connecter avec',
    or_sign_in_with_credentials: 'Ou se connecter avec les identifiants',
    sign_up_with: 'S\'inscrire avec',
    generic_error: 'Une erreur s\'est produite. Veuillez réessayer plus tard.',
    i_agree_with_the: 'J\'accepte les ',
    we_have_sent_you_an_email: 'Nous vous avons envoyé un email :-)',
    email: 'Email',
    password: 'Mot de passe',
    lost_your_password: 'Mot de passe perdu ?',
    recovery_here: 'récupérez-le ici',
    sign_in: 'Se connecter',
    forgot_password: 'Mot de passe oublié ?',
    create_new_account: 'Créer un nouveau compte',
    terms_of_service: 'Conditions d\'utilisation',
    link_privacy: 'Politique de confidentialité',
    term_conditions_text: 'En vous inscrivant ou en vous connectant avec l\'un des services ci-dessus, vous acceptez nos {link_terms} et reconnaissez notre {link_privacy}, qui décrit comment nous gérons vos données personnelles.',
    about_us: 'À propos',
    blog: 'Blog',
    mit_license: 'Licence MIT',
    docs: 'Documentation',
    loading: 'Chargement',
    dashboard: 'Tableau de bord',
    add_new_entry: 'Ajouter une nouvelle entrée',
    add_new_model: 'Ajouter un nouveau modèle',
    my_entries: 'Mes entrées',
    search_entries: 'Rechercher des entrées',
    payee_list: 'Liste des bénéficiaires',
    planned_entries: 'Entrées planifiées',
    budgets: 'Budgets',
    settings: 'Paramètres',
    logout: 'Déconnexion',
    expenses: 'Dépenses',
    incoming: 'Revenus',
    transfer: 'Transfert',
    debit: 'Débits',
    choose_one_of_currently_tags: 'Choisissez un des tags actuels',
    choose_a_wallet_to_transfer_to: 'Choisissez un portefeuille vers lequel transférer',
    choose_wallet_account: 'Choisissez le compte du portefeuille',
    choose_wallet_to_transfer: 'Choisissez un portefeuille vers lequel transférer',
    payment_confirg: 'Confirmer le paiement',
    choose_an_option: 'Choisissez une option',
    choose_a_model: 'Choisissez un modèle',
    out_of_wallet: 'Hors portefeuille',
    insert_new_tag_name: 'Entrez un nouveau nom de TAG',
    add_here_your_note: 'Ajoutez votre note ici',
    insert_new_entry: 'Entrez une nouvelle entrée',
    show_planned_entries: 'Afficher les entrées planifiées',
    show_more: 'Afficher plus',
    restore: 'Restaurer',
    reasume_of_all_entries: 'Résumé de toutes les entrées',
    list_of_all_payees: 'Liste de tous les bénéficiaires',
    forget_debit: 'Oublier le débit',
    date_start: 'Date de début',
    debit_name: 'Nom du débit',
    date_end: 'Date de fin',
    choose_frequency: 'Choisissez une fréquence',
    choose_method: 'Choisissez une méthode',
    insert_new_planned_entry: 'Entrez une nouvelle entrée planifiée',
    create_new_budget: 'Créer un nouveau budget',
    budget_name: 'Nom du budget',
    period: 'Période',
    budget: 'Budget',
    account: 'Compte',
    category: 'Catégorie',
    label: 'Étiquette',
    labels: 'Étiquettes',
    entry_type: 'Type d\'entrée',
    enable_email_notification: 'Activer la notification par email',
    save_budget: 'Enregistrer le budget',
    add_new_wallet: 'Ajouter un nouveau portefeuille',
    show_archived: 'Afficher les archivés',
    wallet_settings: 'Paramètres du portefeuille',
    category_settings: 'Paramètres de catégorie',
    add_new_category: 'Ajouter une nouvelle catégorie',
    category_name: 'Nom de la catégorie',
    save_changes: 'Enregistrer les modifications',
    archive_label: 'Archiver l\'étiquette',
    add_model_entry: 'Ajouter une nouvelle entrée modèle',
    model_settings: 'Paramètres du modèle',
    set_your_default_currency: 'Définir votre devise par défaut',
    currency_settings: 'Paramètres de devise',
    wallets: 'Portefeuilles',
    models: 'Modèles',
    categories: 'Catégories',
    currency: 'Devise',
    profile: 'Profil',
    assistance: 'Assistance',
    my_entry: 'Mon entrée',
    is_planned: 'Planifié',
    add: 'Ajouter',
    model: 'Modèle',
    wallet: 'Portefeuille',
    payee: 'Bénéficiaire',
    frequency: 'Fréquence',
    method: 'Méthode',
    amount: 'Montant',
    date: 'Date',
    tag: 'Tag',
    tags: 'Tags',
    note: 'Note',
    save: 'Enregistrer',
    cancel: 'Annuler',
    close: 'Fermer',
    confirm: 'Confirmer',
    delete: 'Supprimer',
    edit: 'Modifier',
    show: 'Afficher',
    hide: 'Masquer',
    archive: 'Archiver',
    unarchive: 'Désarchiver',
    search: 'Rechercher',
    search_labels: 'Rechercher des étiquettes...',
    or_insert_new_tag_name: 'Ou entrez un nouveau nom d\'étiquette',
    show_details: 'Afficher les détails',
    bounce_rate: 'Taux de rebond',
    session_duration: 'Durée de la session',
    amount_before: 'Montant précédent',
    send_a_request: 'Envoyer une demande',
    change_order: 'Changer l\'ordre',
    add_new_workspace: 'Ajouter un nouvel espace de travail',
    set_up_your_workspaces: 'Configurez vos espaces de travail',
    choose_parent_category: 'Choisissez une catégorie principale',
    exclude_from_stats: 'Exclure des statistiques',
    label_color: 'Couleur de l\'étiquette',
    choose_currency: 'Choisissez une devise',
    choose_wallet_type: 'Choisissez un type de portefeuille',
    payment_deadline: 'Date limite de paiement',
    credit_card_installment: 'Versement de la carte de crédit',
    wallet_color: 'Couleur du portefeuille',
    workspace_settings: 'Paramètres de l\'espace de travail',
    default_currency: 'Devise par défaut',
    default_payment_type: 'Type de paiement par défaut',
    share_workspace_with: 'Partager l\'espace de travail avec',
    share: 'Partager',
    remove: 'Retirer',
    workspace_shared_with: 'Espace de travail partagé avec',
    choose_a_category: 'Choisissez une catégorie',
    payment_confirm: 'Confirmer le paiement',
    my_planned: 'Planifié',
    my_health: 'Santé financière',
    workspace: 'Espace de travail',
    entry_saved: 'Entrée enregistrée avec succès',
    could_not_log_in: 'Impossible de se connecter',
    send_my_password: 'Envoyer un nouveau mot de passe',
    recovery_your_password: 'Récupérez votre mot de passe',
    name: 'Nom',
    confirm_password: 'Confirmer le mot de passe',
    privacy_policy: 'Confidentialité & Politique',
    create_account: 'Créer un nouveau compte',
    click_here: 'Cliquez ici',
    save_template: 'Enregistrer le modèle',
    set_new_password: 'Définir un nouveau mot de passe',
    account_created: 'Compte créé avec succès, veuillez vérifier votre email pour confirmer et activer votre compte',
    search_by_text: 'Rechercher par texte',
    no: 'NON',
    yes: 'OUI',
    date_interval: 'Intervalle de dates',
    type_of_transaction: 'Type de transaction',
    choose_period: 'Choisissez une période',
    daily: 'Quotidien',
    weekly: 'Hebdomadaire',
    monthly: 'Mensuel',
    yearly: 'Annuel',
    one_shot: 'Ponctuel',
    recursive: 'Récurrent',
    or_nsert_new_tag_name: 'Ou entrez un nouveau nom de TAG',
    no_budgets_found: 'Aucun budget trouvé',
    list_of_entries_of: 'Liste des entrées de',
    no_payees_found: 'Aucun bénéficiaire trouvé',
    list_of_all_budgets: 'Liste de tous les budgets',
    list_of_all_planned_entries: 'Liste de toutes les entrées planifiées',
    set_your_default_currecny: 'Définir votre devise par défaut',
    update: 'Mettre à jour',
    stats: 'Statistiques',
    payment_types: 'Types de paiement',
    create_new_debit: 'Créer un nouveau débit',
    months: {
        jan: 'Jan',
        january: 'Janvier',
        feb: 'Fév',
        february: 'Février',
        mar: 'Mar',
        march: 'Mars',
        apr: 'Avr',
        april: 'Avril',
        may: 'Mai',
        jun: 'Juin',
        june: 'Juin',
        jul: 'Juil',
        july: 'Juillet',
        aug: 'Aoû',
        august: 'Août',
        sep: 'Sep',
        september: 'Septembre',
        oct: 'Oct',
        october: 'Octobre',
        nov: 'Nov',
        november: 'Novembre',
        dec: 'Déc',
        december: 'Décembre',
    },
    closing_account_statement: 'Clôture du relevé de compte',
    account_payment: 'Compte de paiement',
    start_date: 'Date de début',
    end_date: 'Date de fin',
    show_entries: 'Afficher les entrées',
    wallet_name: 'Nom du portefeuille',
    balance_wallet: 'Solde du portefeuille',
    wallet_type: 'Type de portefeuille',
    next_execution_time: 'Prochaine date d\'exécution',
    end_time: 'Date de fin',
    no_data_found: 'Aucune donnée trouvée',
    average_incoming: 'Revenus moyens',
    average_savings: 'Économies moyennes',
    your_planned_expenses: 'Dépenses planifiées',
    average_expenses: 'Dépenses moyennes',
    list_of_voices: 'Liste des entrées',
    no_voices_found: 'Aucune entrée trouvée',
    workspace_whared_with: 'Espace de travail partagé avec',
    user_not_found: 'Utilisateur non trouvé',
    save_as_model: 'Enregistrer comme modèle',
    write_temlate_name: 'Écrivez le nom du modèle',
    end_of_month: 'Prévision de fin de mois',
    ticket_value: 'Valeur du bon',
    spent: 'dépensé',
    remaining: 'restant',
    planned: 'planifié',
    no_entries_found: 'Aucune entrée trouvée',
    credit_card_installement: 'Versement de la carte de crédit',
    choose_planned_type: 'Choisissez un type planifié',
    list_of_all_credit_cards: 'Liste de toutes les cartes de crédit',
    details: 'Détails',
    planned_entry: 'Planifié',
    back_to_login: 'Retour à la connexion',
    workspace_name: 'Nom de votre espace de travail',
    first_wallet_name: 'Nom de votre premier portefeuille',
    wallet_amount: 'Solde du portefeuille',
    setup_account: 'Configurer le compte',
    donate: 'Donner',
    faq: 'FAQ',
    start_Date: 'Date de début',
    savings: 'Économies',
    paid_debits: 'Débits',
    given_on_loan: 'Prêté',
    loans: 'Prêts',
    goals: 'Objectifs',
    list_of_all_goals: 'Liste de tous les objectifs',
    no_goals_found: 'Aucun objectif trouvé',
    add_new_goal: 'Ajouter un nouvel objectif',
    target_amount: 'Montant',
    goal_name: 'Nom de l\'objectif',
    goal_target: 'Date d\'échéance',
    goal_note: 'Notes',
    icons: {
        house: 'Maison',
        car: 'Voiture',
        travel: 'Voyage',
        education: 'Éducation',
        health: 'Santé',
        savings: 'Économies',
        retirement: 'Retraite',
        business: 'Affaires',
        charity: 'Charité',
        family: 'Famille',
        hobby: 'Passe-temps',
        investment: 'Investissement',
        emergency: 'Urgence',
        vacation: 'Vacances',
        home_improvement: 'Rénovation',
        technology: 'Technologie',
        pets: 'Animaux',
        other: 'Autre',
    },
    goal_type: 'Type d\'objectif',
    activity: 'Activité',
    deposit: 'Dépôt',
    saved: 'Économisé',
    my_goal: 'Mon objectif',
    my_goals: 'Mes objectifs',
    current_saved: 'Actuellement économisé',
    monthly_deposit: 'Dépôt mensuel',
    due_date: 'Date d\'échéance',
    description: 'Description',
    choose_a_goal: 'Sélectionnez un objectif',
    withdrawal: 'Retrait',
    choose_payment_type: 'Choisissez le type de paiement',
    no_goals_available: 'Aucun objectif disponible',
    create_goal_to_start_saving: 'Créez un objectif pour commencer à économiser',
    create_first_goal: 'Créez votre premier objectif',
    operation_type: 'Type d\'opération',
    attention: 'Attention',
    choose_payee: 'Choisissez un bénéficiaire',
    insert_payee_name: 'Entrez le nom du bénéficiaire',
    wallets_must_be_different: 'Les portefeuilles doivent être différents',
    create_goal_first: 'Créez d\'abord un objectif',
    label_input_hint: 'Vous pouvez ajouter plusieurs étiquettes en les séparant par des espaces',
    no_models_available: 'Aucun modèle disponible',
    create_first_model: 'Créez votre premier modèle',
    your_goal: 'Votre objectif',
    confirm_delete_goal: 'Confirmer la suppression de l\'objectif',
    remaining_expenses: 'Dépenses restantes',
    wallet_management: 'Gestion du portefeuille',
    wallet_management_description: 'Gérez vos portefeuilles, ajoutez-en de nouveaux et définissez votre portefeuille par défaut.',
    add_first_wallet: 'Ajoutez votre premier portefeuille',
    no_wallets_available: 'Aucun portefeuille disponible',
    create_first_wallet: 'Créez votre premier portefeuille',
    archived: 'Archivé',
    last_updated: 'Dernière mise à jour',
    active_wallets: 'Portefeuilles actifs',
    all_wallets: 'Tous les portefeuilles',
    archived_wallets: 'Portefeuilles archivés',
    last_update: 'Dernière mise à jour',
    click_to_create_wallet: 'Cliquez pour créer un portefeuille',
    add_wallet: 'Ajouter un portefeuille',
    credit_card_settings: 'Paramètres de la carte de crédit',
    voucher_settings: 'Paramètres du bon',
    additional_options: 'Options supplémentaires',
    enter_initial_balance: 'Entrez le solde initial',
    edit_wallet: 'Modifier le portefeuille',
    initial_balance: 'Solde initial',
    label_settings: 'Paramètres des étiquettes',
    manage_your_labels: 'Gérez vos étiquettes, ajoutez-en de nouvelles ou archivez celles inutilisées',
    add_new_label: 'Ajouter une nouvelle étiquette',
    edit_label: 'Modifier l\'étiquette',
    add_label: 'Ajouter une étiquette',
    label_name: 'Nom de l\'étiquette',
    active_labels: 'Étiquettes actives',
    all_labels: 'Toutes les étiquettes',
    archived_labels: 'Étiquettes archivées',
    no_labels_found: 'Aucune étiquette trouvée',
    balance: 'Solde',
    active: 'Actif',
    edit_workspace: 'Modifier l\'espace de travail',
    manage_your_workspaces: 'Gérez vos espaces de travail',
    user_shared: 'Utilisateur partagé',
    enter_email: 'Entrez l\'email',
    no_workspaces_found: 'Aucun espace de travail trouvé',
    reset: 'Réinitialiser',
    category_details: 'Détails de la catégorie',
    expenses_by_category_monthly: 'Dépenses par catégorie (mensuel)',
    expenses_by_category_comparison: 'Dépenses par catégorie (comparaison)',
    manage_your_models: 'Gérez vos modèles, ajoutez-en de nouveaux ou archivez ceux inutilisés',
    write_template_name: 'Écrivez le nom du modèle',
    sort_name_asc: 'Nom (A-Z)',
    sort_name_desc: 'Nom (Z-A)',
    sort_amount_desc: 'Montant (Haut-Bas)',
    sort_amount_asc: 'Montant (Bas-Haut)',
    notification_emails: 'E-mails de notification',
    notification_thresholds: 'Seuils de notification',
    notification_threshold_example: 'Ex: 60 pour 60%',
}
</script>